import pepperFlowService from '../../services/pepperFlowService';
import {orderBy} from 'lodash';

const state = {
  connections: [],
  initialized: false,
}

const mutations = {
  setConnections(state, connections) {
    state.connections = connections;
  },
  setInitialized(state, initialized) {
    state.initialized = initialized;
  },
}

const getters = {
  connections: state => state.connections,
  initialized: state => state.initialized,
}

const actions = {
  async initStore({commit, dispatch, getters}, force = false) {
    if (!getters.initialized || force) {
      return Promise.all([
        //dispatch('fetchConnections'),
        //dispatch('fetchVaultObjects', 'country__v').then(response => commit('setCountries', response.data.data)).catch(() => {}),
        //dispatch('fetchVaultObjects', 'language__sys').then(response => commit('setLanguages', response.data.data)).catch(() => {}),
        //dispatch('fetchObjects').catch(() => {}),
        //dispatch('fetchProducts').catch(() => {}),
        //dispatch('fetchVaultObjects', 'website__v').then(response => commit('setWebsites', response.data.data)),*/
      ])
        .then(() => {
          commit('setInitialized', true);
        })
    }
    return Promise.resolve(true);
  },
  fetchConnections({commit}) {
    return pepperFlowService.getConnections()
      .then(data => {
        commit('setConnections', orderBy(data, ['slug'], ['asc']));
      })
      .catch(() => {});
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
